import PageViewer from "@/components/PageViewer";
import PERMISSIONS from "@/common/permissions-lib";

export default {
	path: "/VUHistory",
	meta: {
		breadcrumb: "VU History",
		authorizedRoles: [PERMISSIONS.RSU_VU_TEST_VIEW]
	},
	component: PageViewer,
	props: { pageTransition: "none" },
	children: [
		{
			path: "/",
			name: "VUHistory",
			props: { pageTransition: "none" },
			component: () =>
				import(/* webpackChunkName: "VUHistory" */ "@/views/VUHistory/Index")
		},
		{
			path: "rsu/:rsuId",
			name: "VUHistory.byRsuId",
			redirect: to => {
				const { params } = to;
				return { path: "/VUHistory", query: { rsuId: params["rsuId"] } };
			}
		},
		{
			path: "TFMHistory/:rsuId/:testsetnum",
			name: "DeviceManager.TotalStation.DeviceReport.byRsuId.withTestsetnum",
			props: route => {
				return {
					rsuId: route.params.rsuId,
					testsetnum: route.params.testsetnum
				};
			},
			meta: {
				breadcrumb() {
					return "Test #: " + this.$route.params.testsetnum;
				}
			},
			component: () =>
				import(
					/* webpackChunkName: "DeviceManager.Verification.DeviceReport.byRsuId.withTestsetnum" */ "@/views/DeviceManager/Verification/DeviceReport/Rsu/Testsetnum"
				)
		}
	]
};
